import { jsx, jsxs } from 'react/jsx-runtime';
import clsx from 'clsx';
import { Button } from 'primereact/button';
import { DialogSize } from '../constraints.js';
import { DialogWithDoubleEscape, useDialogClose } from './DialogWithDoubleEscape.js';

function ModalDialog(_ref) {
  let {
    title,
    children,
    onClose,
    size,
    buttons,
    dialogClassName: propsDialogClassName,
    pt
  } = _ref;
  const dialogClassName = clsx('dialog-form', size, propsDialogClassName);
  function HeaderContent() {
    var _a, _b;
    const close = useDialogClose();
    const closeButtonLabel = (_b = (_a = buttons === null || buttons === void 0 ? void 0 : buttons.closeButton) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : 'Close';
    const onCloseButtonClick = () => {
      var _a, _b, _c;
      (_b = (_a = buttons === null || buttons === void 0 ? void 0 : buttons.closeButton) === null || _a === void 0 ? void 0 : _a.callback) === null || _b === void 0 ? void 0 : _b.call(_a);
      if (!((_c = buttons === null || buttons === void 0 ? void 0 : buttons.closeButton) === null || _c === void 0 ? void 0 : _c.overrideDefault)) {
        close();
      }
    };
    return jsxs("div", {
      className: "flex flex-row justify-content-between",
      children: [jsx("div", {
        className: "flex align-items-center",
        children: title
      }), jsx(Button, {
        label: closeButtonLabel,
        outlined: true,
        size: "small",
        onClick: onCloseButtonClick
      })]
    });
  }
  function FooterContent() {
    var _a;
    const close = useDialogClose();
    const footerButtonTemplate = jsx(Button, {
      label: "Close",
      severity: "secondary",
      onClick: close
    });
    return jsxs("div", {
      className: "flex gap-2 justify-content-end",
      children: [(_a = buttons === null || buttons === void 0 ? void 0 : buttons.content) !== null && _a !== void 0 ? _a : null, !(buttons === null || buttons === void 0 ? void 0 : buttons.content) && footerButtonTemplate]
    });
  }
  return jsx(DialogWithDoubleEscape, {
    onClose: onClose,
    className: dialogClassName,
    header: jsx(HeaderContent, {}),
    footer: size !== DialogSize.sm ? undefined : jsx(FooterContent, {}),
    pt: pt,
    children: children
  });
}

export { ModalDialog };
